/* eslint-disable no-mixed-spaces-and-tabs */
import React from "react";
import styled, { ThemeProvider } from "styled-components";
import theme from "styled-theming";

const FillColor = theme.variants("mode", "variant", {
  primary: { main: (props) => props.theme.colors.teal1 },
  distress: { main: (props) => props.theme.colors.signalRed },
  distressactive: { main: (props) => props.theme.colors.teal1 },
  blue: { main: (props) => props.theme.colors.teal1 },
  selected: {
    nav: (props) => props.theme.navigation.select,
    disabled: (props) => props.theme.colors.greyD0,
  },
  unselected: {
    nav: (props) => props.theme.navigation.default,
    disabled: (props) => props.theme.colors.greyD0,
  },
  panelHeader: { main: (props) => props.theme.colors.white },
  userSection: { main: (props) => props.theme.colors.grey33 },
  inInput: { main: (props) => props.theme.colors.black4D },
  link: { main: (props) => props.theme.colors.link },
  light: { main: (props) => props.theme.colors.greyF0 },
});

// styling for svg's

// styling for svg's
const SVG = styled.svg`
  height: 6.5vw;
  width: 6.5vw;
  min-height: 2vw;
  min-width: 2vw;
  margin-left: 1.9em;
  fill: ${FillColor};
  @media screen and (max-width: 500px) {
    font-size: 4vw;
    margin-left: 2em;
  }
`;

const SVGS = styled.svg`
  height: inherit;
  width: inherit;
  max-width: 2em;
  max-height: 2em;
  position: relative;
  top: 2em;
  fill: ${FillColor};
`;

/*const SVG = styled.svg`
  height: inherit;
  width: inherit;
  max-width: 3em;
  max-height:3em;
  position: relative;
  left: 0.9em;
  top: 0.5em;
  font-size: 40px;
  fill: #005A4B;
  @media screen and (max-width: 920px) {
    font-size: 30px;
  }
  @media screen and (max-width: 500px) {
  
  font-size: 35px;
  position: relative;
  top:0.24em;
  left: -2em;
}

  transition: all 0.15s ease-in-out;

`;

const SVGS = styled.svg`
  height: inherit;
  width: inherit;
  position: relative;
  top: 1em;
  max-width: 2em;
  max-height: 2em;
  fill: #005A4B;
`;*/

const SelectIcon = (props) => {
  const { icon, variant, disabled, notext, className } = props;

  switch (icon) {
    case "service":
      return (
        <SVGS
          xmlns="http://www.w3.org/2000/SVG"
          variant={variant || "primary"}
          className={className}
          data-icon-name={icon}
          data-disabled={disabled}
          style={notext ? { marginRight: "0px" } : { marginRight: "0px" }}
          viewBox=""
        >
          <symbol id="service" data-name="service">
            <title>service</title>
          </symbol>
          <path fill="none" d="M0 0h24v24H0V0z" />
          <path d="M2 17h20v2H2zm11.84-9.21c.1-.24.16-.51.16-.79 0-1.1-.9-2-2-2s-2 .9-2 2c0 .28.06.55.16.79C6.25 8.6 3.27 11.93 3 16h18c-.27-4.07-3.25-7.4-7.16-8.21z" />
          <use href={icon ? "#" + icon : "#check"} />{" "}
        </SVGS>
      );

    case "restaurant":
      return (
        <SVG
          xmlns="http://www.w3.org/2000/SVG"
          variant={variant || "primary"}
          className={className}
          data-icon-name={icon}
          data-disabled={disabled}
          style={notext ? { marginRight: "0px" } : { marginRight: "65px" }}
          viewBox="0 3 25 20"
        >
          <symbol id="restaurant" data-name="restaurant">
            <title>restaurant</title>
          </symbol>
          <path d="M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z" />
          <use href={icon ? "#" + icon : "#check"} />{" "}
        </SVG>
      );

    case "wc":
      return (
        <SVG
          xmlns="http://www.w3.org/2000/SVG"
          variant={variant || "primary"}
          className={className}
          data-icon-name={icon}
          data-disabled={disabled}
          style={notext ? { marginRight: "0px" } : { marginRight: "65px" }}
          viewBox="0 3 25 20"
        >
          <symbol id="wc" data-name="wc">
            <title>wc</title>
          </symbol>
          <path fill="none" d="M0 0h24v24H0V0z" />
          <path d="M5.5 22v-7.5H4V9c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v5.5H9.5V22h-4zM18 22v-6h3l-2.54-7.63C18.18 7.55 17.42 7 16.56 7h-.12c-.86 0-1.63.55-1.9 1.37L12 16h3v6h3zM7.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm9 0c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2z" />{" "}
          <use href={icon ? "#" + icon : "#check"} />{" "}
          <use href={icon ? "#" + icon : "#check"} />{" "}
        </SVG>
      );

    case "water":
      return (
        <SVG
          xmlns="http://www.w3.org/2000/SVG"
          variant={variant || "primary"}
          className={className}
          data-icon-name={icon}
          data-disabled={disabled}
          style={notext ? { marginRight: "0px" } : { marginRight: "65px" }}
          viewBox="0 3 25 20"
        >
          <symbol id="water" data-name="water">
            <title>water</title>
          </symbol>
          <path fill="none" d="M0 0h24v24H0V0z" />
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M3 2l2.01 18.23C5.13 21.23 5.97 22 7 22h10c1.03 0 1.87-.77 1.99-1.77L21 2H3zm9 17c-1.66 0-3-1.34-3-3 0-2 3-5.4 3-5.4s3 3.4 3 5.4c0 1.66-1.34 3-3 3zm6.33-11H5.67l-.44-4h13.53l-.43 4z" />
          <use href={icon ? "#" + icon : "#check"} />{" "}
        </SVG>
      );

    case "medicin":
      return (
        <SVG
          xmlns="http://www.w3.org/2000/SVG"
          variant={variant || "primary"}
          className={className}
          data-icon-name={icon}
          data-disabled={disabled}
          style={notext ? { marginRight: "0px" } : { marginRight: "65px" }}
          viewBox="0 3 25 20"
        >
          <symbol id="medicin" data-name="medicin">
            <title>medicin</title>
          </symbol>
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z" />
          <use href={icon ? "#" + icon : "#check"} />{" "}
        </SVG>
      );

    case "bed":
      return (
        <SVG
          xmlns="http://www.w3.org/2000/SVG"
          variant={variant || "primary"}
          className={className}
          data-icon-name={icon}
          data-disabled={disabled}
          style={notext ? { marginRight: "0px" } : { marginRight: "65px" }}
          viewBox="0 0 40 40"
        >
          <symbol id="bed" data-name="bed">
            <title>bed</title>
          </symbol>
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z" />
          <use href={icon ? "#" + icon : "#check"} />{" "}
        </SVG>
      );

    case "bath":
      return (
        <SVG
          xmlns="http://www.w3.org/2000/SVG"
          variant={variant || "primary"}
          className={className}
          data-icon-name={icon}
          data-disabled={disabled}
          style={notext ? { marginRight: "0px" } : { marginRight: "65px" }}
          viewBox="0 0 20 40"
        >
          <symbol id="bath" data-name="bath">
            <title>bath</title>
          </symbol>
          <path d="M0 0h24v24H0z" fill="none" />
          <path
            d="M20,13V4.83C20,3.27,18.73,2,17.17,2c-0.75,0-1.47,0.3-2,0.83l-1.25,1.25C13.76,4.03,13.59,4,13.41,4
			                                                    	c-0.4,0-0.77,0.12-1.08,0.32l2.76,2.76c0.2-0.31,0.32-0.68,0.32-1.08c0-0.18-0.03-0.34-0.07-0.51l1.25-1.25
			                                                    	C16.74,4.09,16.95,4,17.17,4C17.63,4,18,4.37,18,4.83V13h-6.85c-0.3-0.21-0.57-0.45-0.82-0.72l-1.4-1.55
			                                                    	c-0.19-0.21-0.43-0.38-0.69-0.5C7.93,10.08,7.59,10,7.24,10C6,10.01,5,11.01,5,12.25V13H2v6c0,1.1,0.9,2,2,2c0,0.55,0.45,1,1,1
			                                                    	h14c0.55,0,1-0.45,1-1c1.1,0,2-0.9,2-2v-6H20z"
          />
          <use href={icon ? "#" + icon : "#check"} />{" "}
        </SVG>
      );

    case "info":
      return (
        <SVG
          xmlns="http://www.w3.org/2000/SVG"
          variant={variant || "primary"}
          className={className}
          data-icon-name={icon}
          data-disabled={disabled}
          style={notext ? { marginRight: "0px" } : { marginRight: "65px" }}
          viewBox="0 3 25 20"
        >
          <symbol id="info" data-name="info">
            <title>info</title>
          </symbol>
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
          <use href={icon ? "#" + icon : "#check"} />{" "}
        </SVG>
      );
    case "distressgreen":
      return (
        <SVG
          xmlns="http://www.w3.org/2000/SVG"
          variant={variant || "primary"}
          className={className}
          data-icon-name={icon}
          data-disabled={disabled}
          style={notext ? { marginRight: "0px" } : { marginRight: "65px" }}
          viewBox="0 3 25 20"
        >
          <symbol id="distress" data-name="distress">
            <title>distress</title>
          </symbol>
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" />
          <use href={icon ? "#" + icon : "#check"} />{" "}
        </SVG>
      );

    case "distress":
      return (
        <SVG
          xmlns="http://www.w3.org/2000/SVG"
          variant={variant || "distress"}
          className={className}
          data-icon-name={icon}
          data-disabled={disabled}
          style={notext ? { marginRight: "0px" } : { marginRight: "65px" }}
          viewBox="0 3 25 20"
        >
          <symbol id="distressgreen" data-name="distressgreen">
            <title>distressgreen</title>
          </symbol>
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" />
          <use href={icon ? "#" + icon : "#check"} />{" "}
        </SVG>
      );

    default:
    // do nothing
  }
};

const Icon = (props) => {
  const {
    mode,
    noicon,
    variant,
    icon,
    disabled,
    notext,
    linkCategory,
    className,
    title,
  } = props;

  return (
    <ThemeProvider theme={{ mode: mode || "main" }}>
      {noicon
        ? null
        : SelectIcon({
            icon,
            variant,
            disabled,
            notext,
            linkCategory,
            className,
            title,
          })}
    </ThemeProvider>
  );
};

export default Icon;
